module.exports = __webpack_public_path__ + "static/media/envelope.a72c76b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/envelope.svg
// module id = 410
// module chunks = 0